module.exports = __webpack_public_path__ + "static/img/banner01.45727e0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mainpage/banner01.jpg
// module id = hs9V
// module chunks = 18